export default {
    deleteDriverScheduledTasks_deleteConfirmation: 'Are you sure you want to delete the Driver Task ',
    deleteDriverScheduledTasks_success_message: 'Driver Task Removed Successfully',
    deleteDriverScheduledTasks_for: 'for',
}